import { useMemo } from "react"

import * as turf from "@turf/turf"

import { sanitizeData } from "@l2r-front/l2r-geodata"
import { useTranslation } from "@l2r-front/l2r-i18n"
import { Source, useMapDispatchContext } from "@l2r-front/l2r-map"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { useSpeedings } from "../../hooks/queries/useSpeedingsLayer"
import { getGradeFromValue } from "../../utils/valueUtils"

export function SpeedingsSource(props) {

    const { t } = useTranslation(I18N_NAMESPACE)
    const { setError: setMapError } = useMapDispatchContext()

    const { data: speedings } = useSpeedings({
        as_geojson: true,
    }, {
        onError: () => setMapError(true),
        errorSnackbarMessage: t(I18N_NAMESPACE, "containers.speedingsSource.error"),
    })

    // Need to copy id into properties because of that mapbox issue: 
    // link:https://github.com/mapbox/mapbox-gl-js/issues/2716
    const sanitizedData = useMemo(() => {
        if (!speedings) {
            return null
        }

        const speedingsFeatures = speedings.features.map((feature) => {
            const positiveValue = getGradeFromValue(feature.properties.speed_directions?.["+"]?.exceed_5_pct)
            const negativeValue = getGradeFromValue(feature.properties.speed_directions?.["-"]?.exceed_5_pct)
            const value = (positiveValue >= 0 && negativeValue >= 0) ? Math.min(positiveValue, negativeValue) : positiveValue ?? negativeValue ?? -1

            return {
                ...feature,
                properties: {
                    ...feature.properties,
                    exceed_5_pct: value,
                },
            }
        })

        return sanitizeData(turf.featureCollection(speedingsFeatures))

    }, [speedings])

    return (
        <Source {...props} type="geojson" data={sanitizedData} tolerance={.001} />
    )
}

SpeedingsSource.propTypes = Source.propTypes